const defaultState = () => {
	return {
      auditStandardList: null,
      auditStatusList: null,

		auditControlStatusList: null,
      auditControlApplicabilityList: null,
      auditControlAppliedList: null,
		auditEvidenceRequirementStatusList: null,
      auditTaskStatusList: null,
      auditActionPriorityList: null,
      auditExceptionsRiskRatingList: null,

      currentAudit: null,
      hasCurrentAuditLoaded: false,
      controlGroups: null,
      hasControlGroupsLoaded: false,
      controls: null,
      hasControlsLoaded: false,
	}
}

const state = () => ({
   auditStandardList: null,
   auditStatusList: null,

	auditControlStatusList: null,
   auditControlApplicabilityList: null,
   auditControlAppliedList: null,
   auditEvidenceRequirementStatusList: null,
   auditTaskStatusList: null,
   auditActionPriorityList: null,
   auditExceptionsRiskRatingList: null,

   currentAudit: null,
   hasCurrentAuditLoaded: false,
   controlGroups: null,
   hasControlGroupsLoaded: false,
   controls: null,
   hasControlsLoaded: false,
});

const getters = {}

const actions = {
   resetState({ commit }) {
      commit("resetState")
   },
};

const mutations = {
   resetState(state) {
      Object.assign(state, defaultState());
   },

   setAuditStandardList(state, list) {
      state.auditStandardList = list
   },

   setAuditStatusList(state, list) {
      state.auditStatusList = list
   },

   setAuditControlStatusList(state, list) {
      state.auditControlStatusList = list
   },

   setAuditControlApplicabilityList(state, list) {
      state.auditControlApplicabilityList = list
   },

   setAuditControlAppliedList(state, list) {
      state.auditControlAppliedList = list
   },

   setAuditEvidenceRequirementStatusList(state, list) {
      state.auditEvidenceRequirementStatusList = list
   },

   setAuditTaskStatusList(state, list) {
      state.auditTaskStatusList = list
   },

   setAuditActionPriorityList(state, list) {
      state.auditActionPriorityList = list
   },

   setAuditExceptionsRiskRatingList(state, list) {
      state.auditExceptionsRiskRatingList = list
   },

   setCurrentAudit(state, list) {
      state.currentAudit = list
   },

   setHasCurrentAuditLoaded(state, hasLoaded) {
      state.hasCurrentAuditLoaded = hasLoaded
   },

   setAuditControlGroups(state, list) {
      state.controlGroups = list
   },

   setHasAuditControlGroupsLoaded(state, hasLoaded) {
      state.hasControlGroupsLoaded = hasLoaded
   },

   setAuditControls(state, list) {
      state.controls = list
   },

   setHasAuditControlsLoaded(state, hasLoaded) {
      state.hasControlsLoaded = hasLoaded
   },
};

export default {
   name: "audit",
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};